import script from "./FileTypesPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTypesPolicy.vue?vue&type=script&setup=true&lang=js"

import "./FileTypesPolicy.vue?vue&type=style&index=0&id=96177af8&lang=css"

const __exports__ = script;

export default __exports__